export default "//static.tradera.net/touchweb/static/output/images/klarna.1d5ce38e.svg";